var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('titulo-notas-parciais'),_c('filtro-notas-parciais',{on:{"filtrar":_vm.getNotasParciais,"limpar-filtro":_vm.limpar,"limpar-dados":_vm.limparItems}}),_c('tabela-notas-parciais',{attrs:{"items":_vm.items}}),(_vm.aviso)?_c('div',{staticClass:"text-center text-danger my-4"},[_c('span',[_vm._v(_vm._s(_vm.aviso))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }